export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/makers_experience_perseus/apps/Illustration-value-2.f2dac88.svg";